<template>
  <div class="about">
    <div class="main-header">
      <div class="container">
        <div class="header-wrapper">
          <div class="header-left">
            <h1>Lobbies Competitivas</h1>
          </div>

          <div class="header-right">
            <b-button
              block
              v-b-modal.modalLobbyCreate
              variant="primary"
              v-if="!this.$store.getters.lobby.id"
            >Criar lobby</b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <b-modal
        id="modalLobbyCreate"
        title="Criar lobby"
        ref="modalLobbyCreate"
        @ok="handleCreateOk"
      >
        <form @submit.stop.prevent="handleCreateSubmit">
          <b-form-group description label="Nome do Time A">
            <b-form-input v-model="lobby.team1_name" type="text" maxlength="16" placeholder></b-form-input>
          </b-form-group>

          <b-form-group description label="Nome do Time B">
            <b-form-input v-model="lobby.team2_name" type="text" maxlength="16" placeholder></b-form-input>
          </b-form-group>

          <b-form-group description label="Tamanho do Lobby">
            <b-form-select v-model="lobby.players_per_team" class="mb-3">
              <option value="5">5x5</option>
              <option value="3">3x3</option>
              <option value="2">2x2</option>
              <option value="1">1x1</option>
            </b-form-select>
          </b-form-group>

          <b-form-group
            description
            label="Jogar 30 rounds (modo treino)?"
            v-b-tooltip.hover
            title="apenas usuários PREMIUM"
          >
            <b-form-select
              :disabled="!currentUser.is_premium"
              v-model="lobby.is_fullrounds_enabled"
              class="mb-3"
            >
              <option value="false">Não, jogar até um time fazer 16 (padrão)</option>
              <option value="true">Sim, ambos os times jogam 15 rounds de cada lado</option>
            </b-form-select>
          </b-form-group>

          <b-form-group description label="FIGHTBACK Ativo">
            <b-form-select disabled v-model="lobby.is_fightback_enabled" class="mb-3">
              <option value="false">Não</option>
              <option value="true">Sim</option>
            </b-form-select>
          </b-form-group>

          <b-form-group description label="GOTV" v-b-tooltip.hover title="apenas usuários PREMIUM">
            <b-form-select
              :disabled="true || !currentUser.is_premium"
              v-model="lobby.is_gotv_enabled"
              class="mb-3"
            >
              <option value="false">Não</option>
              <option value="true">Sim</option>
            </b-form-select>
          </b-form-group>

          <!-- <b-form-group description="" label="Mapa">
            <b-form-select v-model="lobby.map" class="mb-3">
              <option>de_inferno</option>
              <option>de_dust2</option>
              <option>de_mirage</option>
              <option>de_cache</option>
              <option>de_overpass</option>
              <option>de_cbble</option>
              <option>de_train</option>
              <option>de_subzero</option>
              <option>de_biome</option>
              <option>de_nuke</option>
              <option>aim_ak-colt</option>
              <option>aim_map</option>
              <option>fy_iceworld</option>
              <option>fy_pool_day</option>
              <option>gd_rialto</option>
            </b-form-select>
          </b-form-group>-->
          O mapa será vetado dentro do servidor
        </form>
      </b-modal>

      <div class="lobbies-panel">
        <div class="lobbies-flex">
          <div v-for="lobby in lobbies" :key="lobby.id" :class="['lobby-box', lobby.map]">
            <div class="teams">
              <span v-html="lobby.team1_name"></span>
              X
              <span v-html="lobby.team2_name"></span>
            </div>

            <div class="players">{{lobby.players.length}}/{{lobby.players_per_team * 2}} players</div>

            <p class="map">{{lobby.map}}</p>

            <div class="players-avatars">
              <div v-for="player in lobby.players" :key="player.id" class="player-avatar">
                <img :src="player.avatar">
              </div>
            </div>

            <div class="button-bottom">
              <router-link
                :to="{ name: 'RoomSingle', params: { id: lobby.id }}"
                class="join"
              >Entrar neste Lobby</router-link>
            </div>
          </div>
        </div>

        <div v-if="lobbies.length == 0" class="no-lobbies">
          <div class="lobby-null">
            <h4>Nenhuma lobby disponível no momento</h4>
          </div>
        </div>
      </div>

      <!-- <div class="widget-eac floating">
        <a href="steam://run/282660">
          <h4 class="widget-title">Anti-cheater</h4>
          <p>Para jogar competitivo, você estar com o Easy Anti Cheat baixado e rodando antes de abrir o CS.</p>
          <p class="download">baixe agora e ganhe tempo</p>
          <img src="https://www.easy.ac/static/img/logo-easy.png" alt>
        </a>
      </div>-->
    </div>
  </div>
</template>

<script>
import ActionCable from "actioncable";
export default {
  data: function() {
    return {
      cable: null,
      subscription: null,
      lobbies: [],
      lobbyUrl: "https://QUEOTA.club/lobbies/{{lobbyId}}",
      lobby: {
        map: "de_mirage",
        players_per_team: 5,
        team1_name: "TIME A",
        team2_name: "TIME B",
        is_fightback_enabled: true,
        is_gotv_enabled: true,
        is_fullrounds_enabled: false
      }
    };
  },
  computed: {
  },
  methods: {
    reloadLobbies() {
      var self = this;
      this.$http.get("/lobbies.json").then(response => {
        self.lobbies = response.data;
      });
    },
    handleCreateSubmit() {
      this.$refs.modalLobbyCreate.hide();
    },
    handleCreateOk() {
      this.$http
        .post(`lobbies.json`, { lobby: this.lobby })
        .then(response => {
          this.$refs.modalLobbyCreate.hide();
          this.$router.push({
            name: "RoomSingle",
            params: { id: response.data.id }
          });
        })
        .catch(response => {
          this.$refs.modalLobbyCreate.hide();
          // alert(JSON.stringify(response.data))
        });
    },
    initialize: function() {
      var self = this;
      this.subscription = this.$cable.subscriptions.create(
        {
          channel: "LobbiesRefreshChannel",
          currentUserId: this.$store.getters.user.id
        },
        {
          received: function(data) {
            self.reloadLobbies();
          }
        }
      );
      self.reloadLobbies();

      window.addEventListener(
        "beforeunload",
        function(event) {
          self.subscription.unsubscribe();
        },
        false
      );
    }
  },
  mounted() {
    this.initialize();
  },
  components: {},
  beforeRouteLeave(to, from, next) {
    this.subscription.unsubscribe();
    next();
  }
};
</script>

<style scoped lang="sass">
  .main-header
    width: 100%
    // height: 240px
    background: rgba(0, 0, 0, .85)
    margin-bottom: 40px
    .header-wrapper
      overflow: hidden
      height: 100%
      position: relative
      padding: 30px 0 20px
      display: flex
      @media (max-width: 600px)
        display: block

      .header-left
        flex: 1
        h1
          color: white
          margin-bottom: 0
        h4.subtitle
          color: #aaa
      
      .header-right
        width: 300px
        @media (max-width: 600px)
          width: 100%
  .widget-eac
    // .anti display: inline-block width: 250px img max-width: 150px
    a
      margin: 0 20px 20px
      padding: 20px
      background: rgba(blueviolet, .275)
      display: block
      border-radius: 10px
      text-align: center
      transition: all .1s
      height: 360px
      color: white

      &:hover
        background: rgba(blueviolet, .475)
        text-decoration: none

      h4
        color: white

      p.download
        font-weight: bold
        color: white

      img
        max-width: 100px

    &.floating 
      a
        width: 300px
        position: fixed
        top: 200px
        right: -40px
        opacity: .4
        &:hover
          opacity: 1
  .lobbies-flex
    display: flex
    flex-wrap: wrap
    .lobby-box
      margin: 20px
      width: 250px
      padding: 20px
      height: 300px
      // background: rgba(0, 0, 0, .2)
      border-radius: 10px
      transition: all .1s
      position: relative
      color: #aaa
      &:hover 
        // background: rgba(0, 0, 0, .6)
        color: white
        transform: scale(1.1)

      .players-avatars
        display: flex
        flex-wrap: wrap
        .player-avatar
          width: 32px
          height: 32px
          display: block
          position: relative
          img
            border-radius: 9999px
            height: 100%
            position: relative
            width: 100%
            z-index: 2
            border: 1px solid rgba(255, 255, 255, .2)
            min-height: 32px
            min-width: 32px

      .teams
        font-size: 18px
        span
          font-weight: bold

      .button-bottom
        position: absolute
        bottom: 0
        left: 0
        width: 100%

        a.join
          display: block
          padding: 10px
          margin: 10px
          text-align: center
          border-radius: 10px

          color: rgba(255, 255, 255, .5)

          font-size: 18px
          background: rgb(60,214,40)
          background: linear-gradient(13deg, rgba(60,214,40,0.2) 13%, rgba(39,83,39,0.2) 80%)
      
          font-weight: bold
          transition: all .3s
          font-family: 'Rajdhani', sans-serif
          
          &:hover
            transform: scale(1.1)
            background: rgba(60, 214, 40, .7)
            margin-bottom: 0
            color: white
            text-decoration: none
</style>
